import Immutable from "immutable";
import { call, take, select, put } from "redux-saga/effects";

import {
  getClubBookingByID,
  getClubBookingBasketPrice,
  getClubBookingSelectedSessionIDList,
  getBasketItemsOfType,
  isClubsReady
} from "state/school_money/selectors";
import {
  setBasketItem,
  deleteBasketItem
} from "state/school_money/actions";

import validateBasketItem from "state/school_money/sagas/basketSaga/clubBooking/validateBasketItem";

/**
 * Add a club booking to the basket
 */
export function* addToBasket(action) {
  const { clubBookingID, reserve } = action.payload;
  
  const clubBooking = yield select(getClubBookingByID, clubBookingID);
  const { schoolID, studentID } = clubBooking.toObject();
  const price = reserve ? 0 : yield select(getClubBookingBasketPrice, clubBookingID);
  const sessionIDs = yield select(getClubBookingSelectedSessionIDList, clubBookingID);
  const payload = { clubBookingID, reserve, sessionIDs, clubBooking };
  
  yield put(setBasketItem("clubBooking", clubBookingID, schoolID, studentID, clubBookingID, price, 1, payload));
  
}

/**
 * Remove a club booking from the basket
 */
export function* removeFromBasket(action) {
  const { clubBookingID } = action.payload;
  yield put(deleteBasketItem("clubBooking", clubBookingID));
}

/**
 * Return a list of issues with any club bookings which are currently
 *   in the basket.
 * @returns {Immutable.List}
 */
export function* detectBasketItemsIssues() {
  
  // wait for payments to be loaded
  while (!(yield select(isClubsReady))) {
    yield take();
  }
  
  // get relevant state
  const basketItems = yield select(getBasketItemsOfType, "clubBooking");
  
  // build up a list of issues
  let issues = Immutable.List();
  for (const basketItem of basketItems) {
    const issue = yield call(validateBasketItem, basketItem);
    if (issue) {
      issues = issues.push(issue);
    }
  }
  
  return issues;
  
}

/**
 * Given a list of basket item issues, udate the basket items
 *   in sch a way that all of the issues will be resolved.
 */
export function* resolveBasketItemsIssues(issues) {
  
  if (issues === undefined) {
    return;
  }
  
  // delete basket items that caused issues
  for (const issue of issues) {
    yield put(deleteBasketItem("clubBooking", issue.get("basketItemID")));
  }
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/clubBooking/index.js